import {useTranslation} from '../../i18n/translation';
import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import '../../css/about.css';
import {findElementByLink} from "../utils/siteStructure";
import siteStructure from "../siteStructure.json";
import SeoHelmet from "../utils/seo";
import {useTheme} from "../header/Header";

// Картинки теперь в public → отдаём их как строковые URL.
const Img1 = "/images/about/1.webp";
const Img2 = "/images/about/2.webp";
const Img3 = "/images/about/4.webp";

export default function About() {
    const {english, t} = useTranslation();

    const { theme } = useTheme()

    const location = useLocation();
    const data = findElementByLink(siteStructure, location.pathname.replace(/^\/en(?=\/|$)/, '') || '/')
    const seo = data?.seo? data.seo : {title:"", description:"", keywords:"", changefreq: 'yearly', priority: 0.4}

    const [currentImage, setCurrentImage] = useState(Img2);
    const [isFading, setIsFading] = useState(false);

    const menuItems = [
        {text: "Контакты", image: Img1, nav: '/about/contacts'},
        {text: "О предприятии", image: Img2, nav:'/about/company'},
        {text: "Сеспель в соцсетях", image: Img3, nav: '/about/socialLinks'},
    ];

    const changeImage = (newImage) => {
        if (newImage === currentImage) return;
        setIsFading(true);
        setTimeout(() => {
            setCurrentImage(newImage);
            setIsFading(false);
        }, 500);
    };
    return (
        <div className={`overlay`}>

            <SeoHelmet
                title={t(seo.title)}
                description={t(seo.description)}
            />

            <div className="menuAbout-container">
                <div className={`complexBack ${theme}`}> </div>
                {/* Левое меню */}
                <div className={`menuAbout ${theme}`}>
                    <ul>
                        {menuItems.map((item, index) => (
                            <li key={index}
                                onMouseEnter={() => changeImage(item.image)}
                                className="menuAbout-item"
                            >
                                <Link to={english ? `/en${item.nav}` : item.nav}>{t(item.text)}</Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Блок с изображением */}
                <div className={`menuAbout-image-container ${theme}`}>
                    <img
                        src={currentImage}
                        alt={t(menuItems.find(item => item.image === currentImage).text)}
                        className={`menuAbout-image ${isFading ? "fade-out" : "fade-in"}`}
                    />
                </div>
            </div>
        </div>
    );
}
